import { IFilterObj } from 'src/components/filters/models/filter-response.model';

// eslint-disable-next-line no-shadow
enum DRAWER_VIEW_TYPE {
  PPG,
  SKU,
  COMMENTS,
  TABLE_COMMENT_BOX
}

export default DRAWER_VIEW_TYPE;

export interface IDrawerPayload {
  id: number;
  toggle: string;
  filter_inputs: IFilterObj[];
}

// interface for adding new comment payload
export interface IAddCommentPayload {
  params: {
    ppg_id: number;
    sku_id?: number;
    comment_text: string;
    filter_inputs?: IFilterObj[];
  };
}
